import { Button } from '@applyboard/crystal-ui'
import { ApplicationResource } from '@applyboard/school-applications-types-lib'
import { useEffect } from 'react'
import { useGetApplication, useGetSchool } from '../../hooks'
import styled from '@emotion/styled'
import { useFlywireAction } from '../../hooks/useFlywireAction'

declare global {
  interface Window {
    flywire?: {
      Checkout: {
        render: (config: Record<string, unknown>, selector: string) => void
      }
    }
  }
}

export type FlywireButtonProps = {
  application: ApplicationResource
  onClick: () => void
}

export function FlywireButton(props: Readonly<FlywireButtonProps>): JSX.Element {
  const { isFetchingApplication } = useGetApplication({ id: props.application.id })
  const { school, isLoadingSchool } = useGetSchool()
  const { hiddenButtonRef, handleOnClick, setFlywireDialogTrigger } = useFlywireAction({
    applicationId: props.application.id,
    onSuccess: props.onClick,
  })

  useEffect(() => {
    setFlywireDialogTrigger(props.application, school)
  }, [props.application, school])

  const isLoading = isFetchingApplication || isLoadingSchool

  return (
    <>
      <Button width="fill" intent="primary" loading={isLoading} onClick={handleOnClick}>
        Yes, continue to pay
      </Button>
      <HiddenButton ref={hiddenButtonRef} id="checkout-button" />
    </>
  )
}

const HiddenButton = styled.button({
  display: 'none',
})
